import { useEffect } from "react";
import Hero from "../components/Hero";
import HeroSkeleton from "../components/HeroSkeleton";
import TrustedBy from "../components/TrustedBy";
import StatsQuote from "../components/StatsQuote";
import StudentJourney from "../components/StudentJourney";
import SkillGap from "../components/SkillGap";
import Programmes from "../components/Programmes";
import Testimonials from "../components/Testimonials";
import Mentors from "../components/Mentors";
import NextStepCTA from "../components/NextStepCTA";
// import ReadinessQuiz from "../components/ReadinessQuiz";
import WaitlistCTA from "../components/WaitlistCTA";
import { useGeo } from "../hooks/useGeo";
import { getHeroContent } from "../data/home-data";

export default function HomePage() {
    const { country, loading } = useGeo();
    const heroData = getHeroContent(country);

    useEffect(() => {
        if (loading) {
            console.log("[HomePage] ⏳ Geo loading — showing HeroSkeleton");
        } else {
            const variant = country === "US" ? "🇺🇸 US variant" : "🇮🇳 India (default) variant";
            console.log(`[HomePage] 🎨 Text switch → country="${country}", rendering ${variant}`);
            console.log("[HomePage] 📝 Hero badge:", heroData.badge);
            console.log("[HomePage] 📝 Hero headline parts:", heroData.headlineParts.map(p => p.text).join(" | "));
        }
    }, [country, loading]);

    return (
        <main data-testid="home-page">
            {loading ? <HeroSkeleton /> : <Hero heroData={heroData} />}
            <TrustedBy country={country} />
            <StatsQuote />
            <Programmes />
            {/* <StudentJourney /> */}
            <SkillGap country={country} />

            {/* <Testimonials /> */}
            <Mentors />
            <NextStepCTA country={country} />
            {/* <ReadinessQuiz /> */}
            {/* <WaitlistCTA /> */}
        </main>
    );
}
